import React from 'react';

import { Box, Flex, Grid, Title } from '@mantine/core';
import { DashboardPageWrapper } from 'components/DashboardPageWrapper';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { SmartAssistantTypeCard } from 'pages/SelectSmartAssistantType/SmartAssistantTypeCard';
import { useTranslation } from 'react-i18next';
import { getAgentGroups } from 'shared/utils/smart-assistant';

export function SelectSmartAssistantTypePage() {
  const { t } = useTranslation();
  const [subscription] = useSubscriptionContext();

  return (
    <DashboardPageWrapper title={t('SELECT_SMART_ASSISTANT_TYPE.TITLE')}>
      <Flex h="100%" direction="column">
        {getAgentGroups(subscription).map((group, key: number) => {
          return (
            <Box key={key} my={5}>
              <Box py={0} my={3}>
                <Title order={4}>{group.title}</Title>
              </Box>

              <Grid m={0}>
                {group.items.map((item, key: number) => {
                  return (
                    <Grid.Col span="content" key={key}>
                      <SmartAssistantTypeCard
                        title={item.title}
                        description={item.description}
                        icon={item.icon}
                        isNew={item.isNew}
                        isPreview={item.isPreview}
                        isAccessible={item.isAccessible}
                        type={item.type}
                      />
                    </Grid.Col>
                  );
                })}
              </Grid>
            </Box>
          );
        })}
      </Flex>
    </DashboardPageWrapper>
  );
}
